import { render, staticRenderFns } from "./MediaVideo.vue?vue&type=template&id=623f886e&scoped=true&"
import script from "./MediaVideo.vue?vue&type=script&lang=ts&"
export * from "./MediaVideo.vue?vue&type=script&lang=ts&"
import style0 from "./MediaVideo.vue?vue&type=style&index=0&id=623f886e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f886e",
  null
  
)

export default component.exports